import React from 'react'; 
import HtmlToReact from 'html-to-react';


const CafeCryptoContent = () => {

  const htmlInput = `

    <!DOCTYPE html><!--  This site was created in Webflow. https://www.webflow.com  -->
    <!--  Last Published: Mon Apr 17 2023 14:52:11 GMT+0000 (Coordinated Universal Time)  -->
    <html data-wf-page="64119055c2ce0652f9c28dc9" data-wf-site="64119055c2ce06817ac28dc8">
    <head>
    <meta charset="utf-8">
    <title>LiveProject</title>
    <meta content="width=device-width, initial-scale=1" name="viewport">
    <meta content="Webflow" name="generator">
    <link href="/cafecrypto/css/normalize.css" rel="stylesheet" type="text/css">
    <!-- [if lt IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.min.js" type="text/javascript"></script><![endif] -->
    <script type="text/javascript">!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);</script>
    <link href="images/favicon.ico" rel="shortcut icon" type="image/x-icon">
    <link href="images/webclip.png" rel="apple-touch-icon">

    <style>
    
            @font-face {
  font-family: 'webflow-icons';
  src: url("data:application/x-font-ttf;charset=utf-8;base64,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") format('truetype');
  font-weight: normal;
  font-style: normal;
}
[class^="w-icon-"],
[class*=" w-icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'webflow-icons' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.w-icon-slider-right:before {
  content: "\e600";
}
.w-icon-slider-left:before {
  content: "\e601";
}
.w-icon-nav-menu:before {
  content: "\e602";
}
.w-icon-arrow-down:before,
.w-icon-dropdown-toggle:before {
  content: "\e603";
}
.w-icon-file-upload-remove:before {
  content: "\e900";
}
.w-icon-file-upload-icon:before {
  content: "\e903";
}
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
html {
  height: 100%;
}
body {
  margin: 0;
  min-height: 100%;
  background-color: #fff;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #333;
}
img {
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
}
html.w-mod-touch * {
  background-attachment: scroll !important;
}
.w-block {
  display: block;
}
.w-inline-block {
  max-width: 100%;
  display: inline-block;
}
.w-clearfix:before,
.w-clearfix:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-clearfix:after {
  clear: both;
}
.w-hidden {
  display: none;
}
.w-button {
  display: inline-block;
  padding: 9px 15px;
  background-color: #3898EC;
  color: white;
  border: 0;
  line-height: inherit;
  text-decoration: none;
  cursor: pointer;
  border-radius: 0;
}
input.w-button {
  -webkit-appearance: button;
}
html[data-w-dynpage] [data-w-cloak] {
  color: transparent !important;
}
.w-webflow-badge,
.w-webflow-badge * {
  position: static;
  left: auto;
  top: auto;
  right: auto;
  bottom: auto;
  z-index: auto;
  display: block;
  visibility: visible;
  overflow: visible;
  overflow-x: visible;
  overflow-y: visible;
  box-sizing: border-box;
  width: auto;
  height: auto;
  max-height: none;
  max-width: none;
  min-height: 0;
  min-width: 0;
  margin: 0;
  padding: 0;
  float: none;
  clear: none;
  border: 0 none transparent;
  border-radius: 0;
  background: none;
  background-image: none;
  background-position: 0% 0%;
  background-size: auto auto;
  background-repeat: repeat;
  background-origin: padding-box;
  background-clip: border-box;
  background-attachment: scroll;
  background-color: transparent;
  box-shadow: none;
  opacity: 1;
  transform: none;
  transition: none;
  direction: ltr;
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
  font-size: inherit;
  line-height: inherit;
  font-style: inherit;
  font-variant: inherit;
  text-align: inherit;
  letter-spacing: inherit;
  text-decoration: inherit;
  text-indent: 0;
  text-transform: inherit;
  list-style-type: disc;
  text-shadow: none;
  font-smoothing: auto;
  vertical-align: baseline;
  cursor: inherit;
  white-space: inherit;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
}
.w-webflow-badge {
  position: fixed !important;
  display: inline-block !important;
  visibility: visible !important;
  z-index: 2147483647 !important;
  top: auto !important;
  right: 12px !important;
  bottom: 12px !important;
  left: auto !important;
  color: #AAADB0 !important;
  background-color: #fff !important;
  border-radius: 3px !important;
  padding: 6px 8px 6px 6px !important;
  font-size: 12px !important;
  opacity: 1 !important;
  line-height: 14px !important;
  text-decoration: none !important;
  transform: none !important;
  margin: 0 !important;
  width: auto !important;
  height: auto !important;
  overflow: visible !important;
  white-space: nowrap;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.w-webflow-badge > img {
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
  vertical-align: middle !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: bold;
  margin-bottom: 10px;
}
h1 {
  font-size: 38px;
  line-height: 44px;
  margin-top: 20px;
}
h2 {
  font-size: 32px;
  line-height: 36px;
  margin-top: 20px;
}
h3 {
  font-size: 24px;
  line-height: 30px;
  margin-top: 20px;
}
h4 {
  font-size: 18px;
  line-height: 24px;
  margin-top: 10px;
}
h5 {
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
}
h6 {
  font-size: 12px;
  line-height: 18px;
  margin-top: 10px;
}
p {
  margin-top: 0;
  margin-bottom: 10px;
}
blockquote {
  margin: 0 0 10px 0;
  padding: 10px 20px;
  border-left: 5px solid #E2E2E2;
  font-size: 18px;
  line-height: 22px;
}
figure {
  margin: 0;
  margin-bottom: 10px;
}
figcaption {
  margin-top: 5px;
  text-align: center;
}
ul,
ol {
  margin-top: 0px;
  margin-bottom: 10px;
  padding-left: 40px;
}
.w-list-unstyled {
  padding-left: 0;
  list-style: none;
}
.w-embed:before,
.w-embed:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-embed:after {
  clear: both;
}
.w-video {
  width: 100%;
  position: relative;
  padding: 0;
}
.w-video iframe,
.w-video object,
.w-video embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}
fieldset {
  padding: 0;
  margin: 0;
  border: 0;
}
button,
[type='button'],
[type='reset'] {
  border: 0;
  cursor: pointer;
  -webkit-appearance: button;
}
.w-form {
  margin: 0 0 15px;
}
.w-form-done {
  display: none;
  padding: 20px;
  text-align: center;
  background-color: #dddddd;
}
.w-form-fail {
  display: none;
  margin-top: 10px;
  padding: 10px;
  background-color: #ffdede;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.w-input,
.w-select {
  display: block;
  width: 100%;
  height: 38px;
  padding: 8px 12px;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333333;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
}
.w-input:-moz-placeholder,
.w-select:-moz-placeholder {
  color: #999;
}
.w-input::-moz-placeholder,
.w-select::-moz-placeholder {
  color: #999;
  opacity: 1;
}
.w-input:-ms-input-placeholder,
.w-select:-ms-input-placeholder {
  color: #999;
}
.w-input::-webkit-input-placeholder,
.w-select::-webkit-input-placeholder {
  color: #999;
}
.w-input:focus,
.w-select:focus {
  border-color: #3898EC;
  outline: 0;
}
.w-input[disabled],
.w-select[disabled],
.w-input[readonly],
.w-select[readonly],
fieldset[disabled] .w-input,
fieldset[disabled] .w-select {
  cursor: not-allowed;
}
.w-input[disabled]:not(.w-input-disabled),
.w-select[disabled]:not(.w-input-disabled),
.w-input[readonly],
.w-select[readonly],
fieldset[disabled]:not(.w-input-disabled) .w-input,
fieldset[disabled]:not(.w-input-disabled) .w-select {
  background-color: #eeeeee;
}
textarea.w-input,
textarea.w-select {
  height: auto;
}
.w-select {
  background-color: #f3f3f3;
}
.w-select[multiple] {
  height: auto;
}
.w-form-label {
  display: inline-block;
  cursor: pointer;
  font-weight: normal;
  margin-bottom: 0px;
}
.w-radio {
  display: block;
  margin-bottom: 5px;
  padding-left: 20px;
}
.w-radio:before,
.w-radio:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-radio:after {
  clear: both;
}
.w-radio-input {
  margin: 4px 0 0;
  margin-top: 1px ;
  line-height: normal;
  float: left;
  margin-left: -20px;
}
.w-radio-input {
  margin-top: 3px;
}
.w-file-upload {
  display: block;
  margin-bottom: 10px;
}
.w-file-upload-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -100;
}
.w-file-upload-default,
.w-file-upload-uploading,
.w-file-upload-success {
  display: inline-block;
  color: #333333;
}
.w-file-upload-error {
  display: block;
  margin-top: 10px;
}
.w-file-upload-default.w-hidden,
.w-file-upload-uploading.w-hidden,
.w-file-upload-error.w-hidden,
.w-file-upload-success.w-hidden {
  display: none;
}
.w-file-upload-uploading-btn {
  display: flex;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
  margin: 0;
  padding: 8px 12px;
  border: 1px solid #cccccc;
  background-color: #fafafa;
}
.w-file-upload-file {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  margin: 0;
  padding: 8px 9px 8px 11px;
  border: 1px solid #cccccc;
  background-color: #fafafa;
}
.w-file-upload-file-name {
  font-size: 14px;
  font-weight: normal;
  display: block;
}
.w-file-remove-link {
  margin-top: 3px;
  margin-left: 10px;
  width: auto;
  height: auto;
  padding: 3px;
  display: block;
  cursor: pointer;
}
.w-icon-file-upload-remove {
  margin: auto;
  font-size: 10px;
}
.w-file-upload-error-msg {
  display: inline-block;
  color: #ea384c;
  padding: 2px 0;
}
.w-file-upload-info {
  display: inline-block;
  line-height: 38px;
  padding: 0 12px;
}
.w-file-upload-label {
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
  margin: 0;
  padding: 8px 12px;
  border: 1px solid #cccccc;
  background-color: #fafafa;
}
.w-icon-file-upload-icon,
.w-icon-file-upload-uploading {
  display: inline-block;
  margin-right: 8px;
  width: 20px;
}
.w-icon-file-upload-uploading {
  height: 20px;
}
.w-container {
  margin-left: auto;
  margin-right: auto;
  max-width: 940px;
}
.w-container:before,
.w-container:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-container:after {
  clear: both;
}
.w-container .w-row {
  margin-left: -10px;
  margin-right: -10px;
}
.w-row:before,
.w-row:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-row:after {
  clear: both;
}
.w-row .w-row {
  margin-left: 0;
  margin-right: 0;
}
.w-col {
  position: relative;
  float: left;
  width: 100%;
  min-height: 1px;
  padding-left: 10px;
  padding-right: 10px;
}
.w-col .w-col {
  padding-left: 0;
  padding-right: 0;
}
.w-col-1 {
  width: 8.33333333%;
}
.w-col-2 {
  width: 16.66666667%;
}
.w-col-3 {
  width: 25%;
}
.w-col-4 {
  width: 33.33333333%;
}
.w-col-5 {
  width: 41.66666667%;
}
.w-col-6 {
  width: 50%;
}
.w-col-7 {
  width: 58.33333333%;
}
.w-col-8 {
  width: 66.66666667%;
}
.w-col-9 {
  width: 75%;
}
.w-col-10 {
  width: 83.33333333%;
}
.w-col-11 {
  width: 91.66666667%;
}
.w-col-12 {
  width: 100%;
}
.w-hidden-main {
  display: none !important;
}
@media screen and (max-width: 991px) {
  .w-container {
    max-width: 728px;
  }
  .w-hidden-main {
    display: inherit !important;
  }
  .w-hidden-medium {
    display: none !important;
  }
  .w-col-medium-1 {
    width: 8.33333333%;
  }
  .w-col-medium-2 {
    width: 16.66666667%;
  }
  .w-col-medium-3 {
    width: 25%;
  }
  .w-col-medium-4 {
    width: 33.33333333%;
  }
  .w-col-medium-5 {
    width: 41.66666667%;
  }
  .w-col-medium-6 {
    width: 50%;
  }
  .w-col-medium-7 {
    width: 58.33333333%;
  }
  .w-col-medium-8 {
    width: 66.66666667%;
  }
  .w-col-medium-9 {
    width: 75%;
  }
  .w-col-medium-10 {
    width: 83.33333333%;
  }
  .w-col-medium-11 {
    width: 91.66666667%;
  }
  .w-col-medium-12 {
    width: 100%;
  }
  .w-col-stack {
    width: 100%;
    left: auto;
    right: auto;
  }
}
@media screen and (max-width: 767px) {
  .w-hidden-main {
    display: inherit !important;
  }
  .w-hidden-medium {
    display: inherit !important;
  }
  .w-hidden-small {
    display: none !important;
  }
  .w-row,
  .w-container .w-row {
    margin-left: 0;
    margin-right: 0;
  }
  .w-col {
    width: 100%;
    left: auto;
    right: auto;
  }
  .w-col-small-1 {
    width: 8.33333333%;
  }
  .w-col-small-2 {
    width: 16.66666667%;
  }
  .w-col-small-3 {
    width: 25%;
  }
  .w-col-small-4 {
    width: 33.33333333%;
  }
  .w-col-small-5 {
    width: 41.66666667%;
  }
  .w-col-small-6 {
    width: 50%;
  }
  .w-col-small-7 {
    width: 58.33333333%;
  }
  .w-col-small-8 {
    width: 66.66666667%;
  }
  .w-col-small-9 {
    width: 75%;
  }
  .w-col-small-10 {
    width: 83.33333333%;
  }
  .w-col-small-11 {
    width: 91.66666667%;
  }
  .w-col-small-12 {
    width: 100%;
  }
}
@media screen and (max-width: 479px) {
  .w-container {
    max-width: none;
  }
  .w-hidden-main {
    display: inherit !important;
  }
  .w-hidden-medium {
    display: inherit !important;
  }
  .w-hidden-small {
    display: inherit !important;
  }
  .w-hidden-tiny {
    display: none !important;
  }
  .w-col {
    width: 100%;
  }
  .w-col-tiny-1 {
    width: 8.33333333%;
  }
  .w-col-tiny-2 {
    width: 16.66666667%;
  }
  .w-col-tiny-3 {
    width: 25%;
  }
  .w-col-tiny-4 {
    width: 33.33333333%;
  }
  .w-col-tiny-5 {
    width: 41.66666667%;
  }
  .w-col-tiny-6 {
    width: 50%;
  }
  .w-col-tiny-7 {
    width: 58.33333333%;
  }
  .w-col-tiny-8 {
    width: 66.66666667%;
  }
  .w-col-tiny-9 {
    width: 75%;
  }
  .w-col-tiny-10 {
    width: 83.33333333%;
  }
  .w-col-tiny-11 {
    width: 91.66666667%;
  }
  .w-col-tiny-12 {
    width: 100%;
  }
}
.w-widget {
  position: relative;
}
.w-widget-map {
  width: 100%;
  height: 400px;
}
.w-widget-map label {
  width: auto;
  display: inline;
}
.w-widget-map img {
  max-width: inherit;
}
.w-widget-map .gm-style-iw {
  text-align: center;
}
.w-widget-map .gm-style-iw > button {
  display: none !important;
}
.w-widget-twitter {
  overflow: hidden;
}
.w-widget-twitter-count-shim {
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 28px;
  height: 20px;
  text-align: center;
  background: white;
  border: #758696 solid 1px;
  border-radius: 3px;
}
.w-widget-twitter-count-shim * {
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.w-widget-twitter-count-shim .w-widget-twitter-count-inner {
  position: relative;
  font-size: 15px;
  line-height: 12px;
  text-align: center;
  color: #999;
  font-family: serif;
}
.w-widget-twitter-count-shim .w-widget-twitter-count-clear {
  position: relative;
  display: block;
}
.w-widget-twitter-count-shim.w--large {
  width: 36px;
  height: 28px;
}
.w-widget-twitter-count-shim.w--large .w-widget-twitter-count-inner {
  font-size: 18px;
  line-height: 18px;
}
.w-widget-twitter-count-shim:not(.w--vertical) {
  margin-left: 5px;
  margin-right: 8px;
}
.w-widget-twitter-count-shim:not(.w--vertical).w--large {
  margin-left: 6px;
}
.w-widget-twitter-count-shim:not(.w--vertical):before,
.w-widget-twitter-count-shim:not(.w--vertical):after {
  top: 50%;
  left: 0;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.w-widget-twitter-count-shim:not(.w--vertical):before {
  border-color: rgba(117, 134, 150, 0);
  border-right-color: #5d6c7b;
  border-width: 4px;
  margin-left: -9px;
  margin-top: -4px;
}
.w-widget-twitter-count-shim:not(.w--vertical).w--large:before {
  border-width: 5px;
  margin-left: -10px;
  margin-top: -5px;
}
.w-widget-twitter-count-shim:not(.w--vertical):after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: white;
  border-width: 4px;
  margin-left: -8px;
  margin-top: -4px;
}
.w-widget-twitter-count-shim:not(.w--vertical).w--large:after {
  border-width: 5px;
  margin-left: -9px;
  margin-top: -5px;
}
.w-widget-twitter-count-shim.w--vertical {
  width: 61px;
  height: 33px;
  margin-bottom: 8px;
}
.w-widget-twitter-count-shim.w--vertical:before,
.w-widget-twitter-count-shim.w--vertical:after {
  top: 100%;
  left: 50%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.w-widget-twitter-count-shim.w--vertical:before {
  border-color: rgba(117, 134, 150, 0);
  border-top-color: #5d6c7b;
  border-width: 5px;
  margin-left: -5px;
}
.w-widget-twitter-count-shim.w--vertical:after {
  border-color: rgba(255, 255, 255, 0);
  border-top-color: white;
  border-width: 4px;
  margin-left: -4px;
}
.w-widget-twitter-count-shim.w--vertical .w-widget-twitter-count-inner {
  font-size: 18px;
  line-height: 22px;
}
.w-widget-twitter-count-shim.w--vertical.w--large {
  width: 76px;
}
.w-background-video {
  position: relative;
  overflow: hidden;
  height: 500px;
  color: white;
}
.w-background-video > video {
  background-size: cover;
  background-position: 50% 50%;
  position: absolute;
  margin: auto;
  width: 100%;
  height: 100%;
  right: -100%;
  bottom: -100%;
  top: -100%;
  left: -100%;
  object-fit: cover;
  z-index: -100;
}
.w-background-video > video::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none;
}
.w-background-video--control {
  position: absolute;
  bottom: 1em;
  right: 1em;
  background-color: transparent;
  padding: 0;
}
.w-background-video--control > [hidden] {
  display: none !important;
}
.w-slider {
  position: relative;
  height: 300px;
  text-align: center;
  background: #dddddd;
  clear: both;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
}
.w-slider-mask {
  position: relative;
  display: block;
  overflow: hidden;
  z-index: 1;
  left: 0;
  right: 0;
  height: 100%;
  white-space: nowrap;
}
.w-slide {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 100%;
  height: 100%;
  white-space: normal;
  text-align: left;
}
.w-slider-nav {
  position: absolute;
  z-index: 2;
  top: auto;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  padding-top: 10px;
  height: 40px;
  text-align: center;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
}
.w-slider-nav.w-round > div {
  border-radius: 100%;
}
.w-slider-nav.w-num > div {
  width: auto;
  height: auto;
  padding: 0.2em 0.5em;
  font-size: inherit;
  line-height: inherit;
}
.w-slider-nav.w-shadow > div {
  box-shadow: 0 0 3px rgba(51, 51, 51, 0.4);
}
.w-slider-nav-invert {
  color: #fff;
}
.w-slider-nav-invert > div {
  background-color: rgba(34, 34, 34, 0.4);
}
.w-slider-nav-invert > div.w-active {
  background-color: #222;
}
.w-slider-dot {
  position: relative;
  display: inline-block;
  width: 1em;
  height: 1em;
  background-color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  margin: 0 3px 0.5em;
  transition: background-color 100ms, color 100ms;
}
.w-slider-dot.w-active {
  background-color: #fff;
}
.w-slider-dot:focus {
  outline: none;
  box-shadow: 0px 0px 0px 2px #fff;
}
.w-slider-dot:focus.w-active {
  box-shadow: none;
}
.w-slider-arrow-left,
.w-slider-arrow-right {
  position: absolute;
  width: 80px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  cursor: pointer;
  overflow: hidden;
  color: white;
  font-size: 40px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.w-slider-arrow-left [class^='w-icon-'],
.w-slider-arrow-right [class^='w-icon-'],
.w-slider-arrow-left [class*=' w-icon-'],
.w-slider-arrow-right [class*=' w-icon-'] {
  position: absolute;
}
.w-slider-arrow-left:focus,
.w-slider-arrow-right:focus {
  outline: 0;
}
.w-slider-arrow-left {
  z-index: 3;
  right: auto;
}
.w-slider-arrow-right {
  z-index: 4;
  left: auto;
}
.w-icon-slider-left,
.w-icon-slider-right {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 1em;
  height: 1em;
}
.w-slider-aria-label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.w-slider-force-show {
  display: block !important;
}
.w-dropdown {
  display: inline-block;
  position: relative;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  z-index: 900;
}
.w-dropdown-btn,
.w-dropdown-toggle,
.w-dropdown-link {
  position: relative;
  vertical-align: top;
  text-decoration: none;
  color: #222222;
  padding: 20px;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  white-space: nowrap;
}
.w-dropdown-toggle {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: inline-block;
  cursor: pointer;
  padding-right: 40px;
}
.w-dropdown-toggle:focus {
  outline: 0;
}
.w-icon-dropdown-toggle {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  margin-right: 20px;
  width: 1em;
  height: 1em;
}
.w-dropdown-list {
  position: absolute;
  background: #dddddd;
  display: none;
  min-width: 100%;
}
.w-dropdown-list.w--open {
  display: block;
}
.w-dropdown-link {
  padding: 10px 20px;
  display: block;
  color: #222222;
}
.w-dropdown-link.w--current {
  color: #0082f3;
}
.w-dropdown-link:focus {
  outline: 0;
}
@media screen and (max-width: 767px) {
  .w-nav-brand {
    padding-left: 10px;
  }
}

.w-lightbox-backdrop {
  cursor: auto;
  font-style: normal;
  letter-spacing: normal;
  list-style: disc;
  text-indent: 0;
  text-shadow: none;
  text-transform: none;
  visibility: visible;
  white-space: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  color: #fff;
  font-family: "Helvetica Neue", Helvetica, Ubuntu, "Segoe UI", Verdana, sans-serif;
  font-size: 17px;
  line-height: 1.2;
  font-weight: 300;
  text-align: center;
  background: rgba(0, 0, 0, 0.9);
  z-index: 2000;
  outline: 0;
  opacity: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-transform: translate(0, 0);
 
}

.w-lightbox-backdrop,
.w-lightbox-container {
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.w-lightbox-content {
  position: relative;
  height: 100vh;
  overflow: hidden;
}
.w-lightbox-view {
  position: absolute;
  width: 100vw;
  height: 100vh;
  opacity: 0;
}
.w-lightbox-view:before {
  content: "";
  height: 100vh;
}
.w-lightbox-group,
.w-lightbox-group .w-lightbox-view,
.w-lightbox-group .w-lightbox-view:before {
  height: 86vh;
}
.w-lightbox-frame,
.w-lightbox-view:before {
  display: inline-block;
  vertical-align: middle;
}

.w-lightbox-figure {
  position: relative;
  margin: 0;
}
.w-lightbox-group .w-lightbox-figure {
  cursor: pointer;
}

.w-lightbox-img {
  width: auto;
  height: auto;
  max-width: none;
}

.w-lightbox-image {
  display: block;
  float: none;
  max-width: 100vw;
  max-height: 100vh;
}
.w-lightbox-group .w-lightbox-image {
  max-height: 86vh;
}
.w-lightbox-caption {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0.5em 1em;
  background: rgba(0, 0, 0, 0.4);
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.w-lightbox-embed {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.w-lightbox-control {
  position: absolute;
  top: 0;
  width: 4em;
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
.w-lightbox-left {
  display: none;
  bottom: 0;
  left: 0;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0yMCAwIDI0IDQwIiB3aWR0aD0iMjQiIGhlaWdodD0iNDAiPjxnIHRyYW5zZm9ybT0icm90YXRlKDQ1KSI+PHBhdGggZD0ibTAgMGg1djIzaDIzdjVoLTI4eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDN2MjNoMjN2M2gtMjZ6IiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg==");
}
.w-lightbox-right {
  display: none;
  right: 0;
  bottom: 0;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMjQgNDAiIHdpZHRoPSIyNCIgaGVpZ2h0PSI0MCI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMC0waDI4djI4aC01di0yM2gtMjN6IiBvcGFjaXR5PSIuNCIvPjxwYXRoIGQ9Im0xIDFoMjZ2MjZoLTN2LTIzaC0yM3oiIGZpbGw9IiNmZmYiLz48L2c+PC9zdmc+");
}

.w-lightbox-close {
  right: 0;
  height: 2.6em;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMTggMTciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMCAwaDd2LTdoNXY3aDd2NWgtN3Y3aC01di03aC03eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDd2LTdoM3Y3aDd2M2gtN3Y3aC0zdi03aC03eiIgZmlsbD0iI2ZmZiIvPjwvZz48L3N2Zz4=");
  background-size: 18px;
}

.w-lightbox-strip {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 1vh;
  line-height: 0;
  /* 1 */
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}

.w-lightbox-item {
  display: inline-block;
  width: 10vh;
  padding: 2vh 1vh;
  box-sizing: content-box;
  /* 1 */
  cursor: pointer;
  -webkit-transform: translate3d(0, 0, 0);
  /* 2 */
}
.w-lightbox-active {
  opacity: 0.3;
}
.w-lightbox-thumbnail {
  position: relative;
  height: 10vh;
  background: #222;
  overflow: hidden;
}
.w-lightbox-thumbnail-image {
  position: absolute;
  top: 0;
  left: 0;
}
.w-lightbox-thumbnail .w-lightbox-tall {
  top: 50%;
  width: 100%;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);
}
.w-lightbox-thumbnail .w-lightbox-wide {
  left: 50%;
  height: 100%;
  -webkit-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}
/*
 * Spinner
 *
 * Absolute pixel values are used to avoid rounding errors that would cause
 * the white spinning element to be misaligned with the track.
 */
.w-lightbox-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  margin-top: -20px;
  margin-left: -20px;
  border: 5px solid rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  -webkit-animation: spin 0.8s infinite linear;
  animation: spin 0.8s infinite linear;
}
.w-lightbox-spinner:after {
  content: "";
  position: absolute;
  top: -4px;
  right: -4px;
  bottom: -4px;
  left: -4px;
  border: 3px solid transparent;
  border-bottom-color: #fff;
  border-radius: 50%;
}
/*
 * Utility classes
 */
.w-lightbox-hide {
  display: none;
}
.w-lightbox-noscroll {
  overflow: hidden;
}
@media (min-width: 768px) {
  .w-lightbox-content {
    height: 96vh;
    margin-top: 2vh;
  }
  .w-lightbox-view,
  .w-lightbox-view:before {
    height: 96vh;
  }
  /* .w-lightbox-content */
  .w-lightbox-group,
  .w-lightbox-group .w-lightbox-view,
  .w-lightbox-group .w-lightbox-view:before {
    height: 84vh;
  }
  .w-lightbox-image {
    max-width: 96vw;
    max-height: 96vh;
  }
  .w-lightbox-group .w-lightbox-image {
    max-width: 82.3vw;
    max-height: 84vh;
  }
  .w-lightbox-left,
  .w-lightbox-right {
    display: block;
    opacity: 0.5;
  }
  .w-lightbox-close {
    opacity: 0.8;
  }
  .w-lightbox-control:hover {
    opacity: 1;
  }
}
.w-lightbox-inactive,
.w-lightbox-inactive:hover {
  opacity: 0;
}
.w-richtext:before,
.w-richtext:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-richtext:after {
  clear: both;
}
.w-richtext[contenteditable="true"]:before,
.w-richtext[contenteditable="true"]:after {
  white-space: initial;
}
.w-richtext ol,
.w-richtext ul {
  overflow: hidden;
}
.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-video div:after,
.w-richtext .w-richtext-figure-selected[data-rt-type="video"] div:after {
  outline: 2px solid #2895f7;
}
.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-image div,
.w-richtext .w-richtext-figure-selected[data-rt-type="image"] div {
  outline: 2px solid #2895f7;
}
.w-richtext figure.w-richtext-figure-type-video > div:after,
.w-richtext figure[data-rt-type="video"] > div:after {
  content: '';
  position: absolute;
  display: none;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.w-richtext figure {
  position: relative;
  max-width: 60%;
}
.w-richtext figure > div:before {
  cursor: default!important;
}
.w-richtext figure img {
  width: 100%;
}
.w-richtext figure figcaption.w-richtext-figcaption-placeholder {
  opacity: 0.6;
}
.w-richtext figure div {
  /* fix incorrectly sized selection border in the data manager */
  font-size: 0px;
  color: transparent;
}
.w-richtext figure.w-richtext-figure-type-image,
.w-richtext figure[data-rt-type="image"] {
  display: table;
}
.w-richtext figure.w-richtext-figure-type-image > div,
.w-richtext figure[data-rt-type="image"] > div {
  display: inline-block;
}
.w-richtext figure.w-richtext-figure-type-image > figcaption,
.w-richtext figure[data-rt-type="image"] > figcaption {
  display: table-caption;
  caption-side: bottom;
}
.w-richtext figure.w-richtext-figure-type-video,
.w-richtext figure[data-rt-type="video"] {
  width: 60%;
  height: 0;
}
.w-richtext figure.w-richtext-figure-type-video iframe,
.w-richtext figure[data-rt-type="video"] iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.w-richtext figure.w-richtext-figure-type-video > div,
.w-richtext figure[data-rt-type="video"] > div {
  width: 100%;
}
.w-richtext figure.w-richtext-align-center {
  margin-right: auto;
  margin-left: auto;
  clear: both;
}
.w-richtext figure.w-richtext-align-center.w-richtext-figure-type-image > div,
.w-richtext figure.w-richtext-align-center[data-rt-type="image"] > div {
  max-width: 100%;
}
.w-richtext figure.w-richtext-align-normal {
  clear: both;
}
.w-richtext figure.w-richtext-align-fullwidth {
  width: 100%;
  max-width: 100%;
  text-align: center;
  clear: both;
  display: block;
  margin-right: auto;
  margin-left: auto;
}
.w-richtext figure.w-richtext-align-fullwidth > div {
  display: inline-block;
  /* padding-bottom is used for aspect ratios in video figures
      we want the div to inherit that so hover/selection borders in the designer-canvas
      fit right*/
  padding-bottom: inherit;
}
.w-richtext figure.w-richtext-align-fullwidth > figcaption {
  display: block;
}
.w-richtext figure.w-richtext-align-floatleft {
  float: left;
  margin-right: 15px;
  clear: none;
}
.w-richtext figure.w-richtext-align-floatright {
  float: right;
  margin-left: 15px;
  clear: none;
}
.w-nav {
  position: relative;
  background: #dddddd;
  z-index: 1000;
}
.w-nav:before,
.w-nav:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-nav:after {
  clear: both;
}
.w-nav-brand {
  position: relative;
  float: left;
  text-decoration: none;
  color: #333333;
}
.w-nav-link {
  position: relative;
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  color: #222222;
  padding: 20px;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
}
.w-nav-link.w--current {
  color: #0082f3;
}
.w-nav-menu {
  position: relative;
  float: right;
}
[data-nav-menu-open] {
  display: block !important;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #C8C8C8;
  text-align: center;
  overflow: visible;
  min-width: 200px;
}
.w--nav-link-open {
  display: block;
  position: relative;
}
.w-nav-overlay {
  position: absolute;
  overflow: hidden;
  display: none;
  top: 100%;
  left: 0;
  right: 0;
  width: 100%;
}
.w-nav-overlay [data-nav-menu-open] {
  top: 0;
}
.w-nav[data-animation="over-left"] .w-nav-overlay {
  width: auto;
}
.w-nav[data-animation="over-left"] .w-nav-overlay,
.w-nav[data-animation="over-left"] [data-nav-menu-open] {
  right: auto;
  z-index: 1;
  top: 0;
}
.w-nav[data-animation="over-right"] .w-nav-overlay {
  width: auto;
}
.w-nav[data-animation="over-right"] .w-nav-overlay,
.w-nav[data-animation="over-right"] [data-nav-menu-open] {
  left: auto;
  z-index: 1;
  top: 0;
}
.w-nav-button {
  position: relative;
  float: right;
  padding: 18px;
  font-size: 24px;
  display: none;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.w-nav-button:focus {
  outline: 0;
}
.w-nav-button.w--open {
  background-color: #C8C8C8;
  color: white;
}
.w-nav[data-collapse="all"] .w-nav-menu {
  display: none;
}
.w-nav[data-collapse="all"] .w-nav-button {
  display: block;
}
.w--nav-dropdown-open {
  display: block;
}
.w--nav-dropdown-toggle-open {
  display: block;
}
.w--nav-dropdown-list-open {
  position: static;
}
@media screen and (max-width: 991px) {
  .w-nav[data-collapse="medium"] .w-nav-menu {
    display: none;
  }
  .w-nav[data-collapse="medium"] .w-nav-button {
    display: block;
  }
}
@media screen and (max-width: 767px) {
  .w-nav[data-collapse="small"] .w-nav-menu {
    display: none;
  }
  .w-nav[data-collapse="small"] .w-nav-button {
    display: block;
  }
  .w-nav-brand {
    padding-left: 10px;
  }
}
@media screen and (max-width: 479px) {
  .w-nav[data-collapse="tiny"] .w-nav-menu {
    display: none;
  }
  .w-nav[data-collapse="tiny"] .w-nav-button {
    display: block;
  }
}
.w-tabs {
  position: relative;
}
.w-tabs:before,
.w-tabs:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}
.w-tabs:after {
  clear: both;
}
.w-tab-menu {
  position: relative;
}
.w-tab-link {
  position: relative;
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  padding: 9px 30px;
  text-align: left;
  cursor: pointer;
  color: #222222;
  background-color: #dddddd;
}
.w-tab-link.w--current {
  background-color: #C8C8C8;
}
.w-tab-link:focus {
  outline: 0;
}
.w-tab-content {
  position: relative;
  display: block;
  overflow: hidden;
}
.w-tab-pane {
  position: relative;
  display: none;
}
.w--tab-active {
  display: block;
}
@media screen and (max-width: 479px) {
  .w-tab-link {
    display: block;
  }
}
.w-ix-emptyfix:after {
  content: "";
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.w-dyn-empty {
  padding: 10px;
  background-color: #dddddd;
}
.w-dyn-hide {
  display: none !important;
}
.w-dyn-bind-empty {
  display: none !important;
}
.w-condition-invisible {
  display: none !important;
}

    </style>

    <style>
        .w-embed-youtubevideo {
            width: 100%;
            position: relative;
            padding-bottom: 0px;
            padding-left: 0px;
            padding-right: 0px;
            background-image: url('https://d3e54v103j8qbb.cloudfront.net/static/youtube-placeholder.2b05e7d68d.svg');
            background-size: cover;
            background-position: 50% 50%;
            }

            .w-embed-youtubevideo:empty {
            min-height: 75px;
            padding-bottom: 56.25%;
            }
            
                
            .w-layout-grid {
            display: -ms-grid;
            display: grid;
            grid-auto-columns: 1fr;
            -ms-grid-columns: 1fr 1fr;
            grid-template-columns: 1fr 1fr;
            -ms-grid-rows: auto auto;
            grid-template-rows: auto auto;
            grid-row-gap: 16px;
            grid-column-gap: 26px;
            }

            body {
            font-family: 'The northern block ltd typold', sans-serif;
            color: #333;
            font-size: 14px;
            line-height: 20px;
            }

            .body {
            font-family: 'The northern block ltd typold', sans-serif;
            }

            .container.navbar {
            display: flex;
            padding-top: 22px;
            padding-bottom: 22px;
            justify-content: space-between;
            align-items: center;
            background-color: #161724;
            color: #f8f2f2;
            }

            .container.header {
            display: block;
            padding-top: 100px;
            padding-bottom: 100px;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            color: #161724;
            }

            .navbar_buton {
            padding: 12px 19px;
            border-radius: 10px;
            background-color: teal;
            }

            .nav-link {
            color: #f8f2f2;
            }

            .nav-link-2 {
            color: #f8f2f2;
            }

            .nav-link-3 {
            color: #f8f2f2;
            }

            .navbar-2 {
            padding-right: 60px;
            padding-left: 60px;
            background-color: #161724;
            }

            .nav-link-4 {
            color: #f8f2f2;
            }

            .nav-_menu {
            display: flex;
            justify-content: space-between;
            align-items: center;
            grid-column-gap: 20px;
            grid-row-gap: 0px;
            }

            .navbar__logo {
            width: 120px;
            height: 31px;
            background-image: url('../images/Vectors-Wrapper.svg');
            background-position: 50% 50%;
            background-size: contain;
            background-repeat: no-repeat;
            }

            .section {
            margin-top: 200px;
            padding-right: 40px;
            padding-bottom: 0px;
            padding-left: 40px;
            }

            .section.header {
            margin-top: 0px;
            padding-right: 40px;
            padding-left: 40px;
            background-color: #161724;
            }

            .section.who {
            margin-top: 120px;
            margin-bottom: 120px;
            }

            .section.live-section {
            margin-top: 130px;
            padding-right: 0px;
            padding-left: 0px;
            /* background-image: linear-gradient(219.31deg, teal, #23253d); */
            /* background-image: linear-gradient(219.31deg, #2c3e50 10%, #23253d 50%, teal 100%); */
            background-image: linear-gradient(219.31deg, teal 10%, #23253d 50%, #2c3e50 100%);


            }

            .section.client {
            margin-top: 200px;
            }

            .titre-1 {
            display: flex;
            width: 135px;
            height: 41px;
            margin-right: auto;
            margin-left: auto;
            justify-content: center;
            align-items: center;
            border-style: solid;
            border-width: 1px;
            border-color: rgba(255, 120, 132, 0.3);
            border-radius: 50px;
            }

            .titre-1.header {
            width: 184px;
            height: 47px;
            }

            .text-block {
            color: #f8f2f2;
            font-size: 25px;
            font-weight: 400;
            }

            .header_heading {
            color: #f8f2f2;
            font-size: 50px;
            line-height: 76px;
            font-weight: 300;
            text-align: center;
            letter-spacing: -3px;
            }

            .header_heading.t2 {
            font-size: 50px;
            line-height: 82px;
            font-weight: 500;
            }

            .header_heading_title {
            margin-top: 30px;
            padding-top: 0px;
            padding-bottom: 0px;
            }

            .header_textblock {
            margin-top: 35px;
            margin-bottom: 35px;
            color: #f8f2f2;
            font-size: 25px;
            line-height: 30px;
            font-weight: 100;
            text-align: center;
            letter-spacing: -1px;
            }
            .circle {
            width: 19px; /* Taille du cercle */
            height: 19px;
            background-color: #DC3F4D; /* Couleur du cercle */
            border-radius: 50%; /* Rend le div circulaire */
            margin-right: 0px; /* Espacement entre le cercle et le texte */
            margin-top:1.5rem;
            }

            .button {
            display: flex;
            width: 190px;
            height: 50px;
            margin-right: auto;
            margin-left: auto;
            padding: 20px 17px;
            /* padding: 15px 20px; */
            justify-content: center;
            align-items: center;
            border-radius: 15px;
            background-color: teal;
            background-image: linear-gradient(212deg, teal, #161724);
            color: #80bfbf;
            font-size: 18px;
            font-weight: 500;
            }

            .button:hover {
            box-shadow: 0 0 70px 10px teal;
            color: #f8f2f2;
            }

            .heder_video {
            margin-top: 75px;
            margin-bottom: 75px;
            border-style: none;
            border-width: 1px;
            border-color: #f8f2f2;
            border-radius: 50px;
            opacity: 1;
            }

            .header_video_section {
            border-radius: 50px;
            }

            .header_title_cta {
            display: flex;
            margin-top: 0px;
            margin-bottom: 0px;
            padding-top: 20px;
            padding-bottom: 20px;
            justify-content: center;
            align-items: center; 
            grid-column-gap: 10px;
            }

            .heder_title_01 {
            color: #f8f2f2;
            font-size: 47px;
            line-height: 70px;
            font-weight: 500;
            
            margin-left:3rem;
            }

            .header_title_02 {
            width: 1100px;
            color: #f8f2f2;
            font-size: 26px;
            line-height: 39px;
            font-weight: 100;
            margin-left: 2rem;
            }

            .div-block {
            margin-left: 100px;
            }

            .who_title {
            display: flex;
            margin-right: 0px;
            margin-left: 0px;
            justify-content: center;
            align-items: center;
            width: 100%; /* Garde la largeur de 100% */
            padding: 0 20px; /* Ajoute du padding à gauche et à droite pour respirer */
            box-sizing: border-box; /* Assure que le padding n'affecte pas la largeur totale */

            }

            .who_title_01 {
            display: flex;
            max-width: 60%;
            flex-direction: column;
            justify-content: center;
            }


            .who_title_02 {
            /*  width: 871px; */
            width: 40%;
            max-width: 971px;
            font-size: 30px;
            line-height: 38px;
            font-weight: 300;
            letter-spacing: -1.5px;
            }

            .who_title_text_01 {
            width: 409px;
            font-size: 35px;
            line-height: 56px;
            font-weight: 500;
            letter-spacing: -2.5px;

            }

            .who_title_text_02 {
            width: 909px;
            color: #8b8c8f;
            font-size: 35px;
            line-height: 100%;
            font-weight: 500;
            letter-spacing: -2.5px;
            }

            .who_crypto {
            display: flex;
            height: auto;
            max-height: 568px;
            margin-top: 80px;
            flex-direction: row;
            justify-content: space-between;
            flex-wrap: nowrap;
            align-items: stretch;
            }

            .div-block-2 {
            width: 585px;
            height: 550px;
            }

            .who_crypto_01 {
            width: 585px;
            height: 563px;
            max-width: 585px;
            border-radius: 40px;
            background-color: #cdddff;
            }

            .who_crypto_element {
            display: flex;
            margin: 30px 35px;
            padding-top: 0px;
            padding-bottom: 0px;
            align-items: center;
            }

            .text-block-2 {
            width: 422px;
            font-size: 50px;
            line-height: 62px;
            font-weight: 500;
            }

            .text-block-3 {
            width: 463px;
            margin-right: 35px;
            margin-left: 35px;
            font-size: 25px;
            line-height: 38px;
            font-weight: 300;
            }

            .div-block-3 {
            display: flex;
            height: 385px;
            margin: -78px auto;
            justify-content: center;
            align-items: center;
            background-image: url('../images/crypto-img-1.png');
            background-position: 50% 50%;
            background-size: cover;
            background-repeat: no-repeat;
            -o-object-fit: cover;
                object-fit: cover;
            }

            .who_image_01 {
            height: 252px;
            -o-object-fit: cover;
                object-fit: cover;
            }

            .image {
            margin-top: -135px;
            margin-bottom: -135px;
            padding-top: 0px;
            padding-bottom: 0px;
            }

            .who_image_prs_01 {
            -o-object-fit: cover;
                object-fit: cover;
            }

            .who_crypto_02 {
            display: flex;
            height: auto;
            flex-direction: column;
            justify-content: space-between;
            align-items: stretch;
            -o-object-fit: fill;
                object-fit: fill;
            }

            .who_image_02 {
            -o-object-fit: cover;
                object-fit: cover;
            }

            .who_image_03 {
            -o-object-fit: cover;
                object-fit: cover;
            }

            .who-condition {
            display: flex;
            width: 100%;
            height: 366px;
            margin-top: 50px;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            grid-column-gap: 22px;
            grid-row-gap: 22px;
            }

            .who-condition-01 {
            display: flex;
            width: 100%;
            height: 58px;
            justify-content: flex-start;
            align-items: flex-start;
            grid-column-gap: 10px;
            grid-row-gap: 10px;
            }

            .text {
            color: #23253d;
            font-size: 35px;
            line-height: 62px;
            font-weight: 500;
            letter-spacing: -0.05em;
            }

            .who-condition-02 {
            display: flex;
            width: 100%;
            height: 100px;
            justify-content: flex-start;
            align-items: flex-start;
            grid-column-gap: 10px;
            grid-row-gap: 10px;
            }

            .text-2 {
            color: #23253d;
            font-size: 30px;
            line-height: 43px;
            font-weight: 500;
            letter-spacing: -0.05em;
            }

            .who-condition-03 {
            display: flex;
            width: 100%;
            height: 108px;
            justify-content: flex-start;
            align-items: flex-start;
            grid-column-gap: 10px;
            grid-row-gap: 10px;
            }

            .text-3 {
            color: #23253d;
            font-size: 25px;
            line-height: 34px;
            font-weight: 300;
            letter-spacing: -0.05em;
            }

            .advantage-section {
            display: flex;
            justify-content: space-around;
            align-items: flex-start;
            flex: 0 auto;
            grid-column-gap: 166px;
            grid-row-gap: 141px;
            }

            .container-2 {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            grid-column-gap: 141px;
            grid-row-gap: 141px;
            }

            .advantage-1 {
            display: flex;
            width: 100%;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            grid-column-gap: 70px;
            grid-row-gap: 70px;
            }

            .title-advantage-section {
            display: flex;
            width: 100%;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            }

            .advantage-title {
            display: flex;
            max-width: 578px;
            margin-top: 32px;
            justify-content: flex-start;
            align-items: flex-start;
            }

            .text-4 {
            color: #23253d;
            font-size: 40px;
            line-height: 100%;
            font-weight: 500;
            letter-spacing: -0.08em;
            }

            .vous-tes-un-professionnel-ou-un-expert-du-domaine-des-cryptomonnaies-partagez-vos-connaissances-en-tant-que-speaker-sur-les-lives-de-caf-crypto {
            color: #23253d;
            font-size: 22px;
            line-height: 135%;
            font-weight: 300;
            letter-spacing: -0.05em;
            }

            .frame-7477-1 {
            -o-object-fit: contain;
                object-fit: contain;
            }

            .advantage-2 {
            display: flex;
            width: 100%;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            grid-row-gap: 50px;
            }

            .live-section {
            display: flex;
            padding-top: 40px;
            padding-bottom: 40px;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            grid-column-gap: 10px;
            grid-row-gap: 10px;
            /* background-image: linear-gradient(219.31deg, teal, #23253d); */
            /* background-image: linear-gradient(219.31deg, #2c3e50 10%, #23253d 50%, teal 100%); */
            background-image: linear-gradient(219.31deg, teal 10%, #23253d 50%, #2c3e50 100%);

            }

            .live-section.container {
            max-width: none;
            justify-content: center;
            align-items: center;
            }

            .container-3 {
            display: flex;
            margin-right: auto;
            margin-left: auto;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            grid-row-gap: 111px;
            }

            .section-live-title {
            display: flex;
            width: 100%;
            max-width: 1050px;
            justify-content: flex-start;
            align-items: center;
            grid-column-gap: 118px;
            grid-row-gap: 118px;
            }

            .live-title {
            display: flex;
            width: 60%;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            grid-column-gap: 0px;
            grid-row-gap: 0px;
            
            }

            .live-title-02 {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex: 0 auto;
            grid-column-gap: 10px;
            grid-row-gap: 10px;
            }

            .text-5 {
            color: #fff;
            font-size: 50px;
            line-height: 4rem;
            font-weight: 500;
            letter-spacing: -0.05em;
            }

            .text-6 {
            color: #cbebdc;
            font-size: 50px;
            line-height: 100%;
            font-weight: 500;
            letter-spacing: -0.05em;
            }

            .text-7 {
            color: #fff;
            font-size: 20px;
            line-height: 120%;
            font-weight:100;
            margin-right: 5rem;
            
            }

            .live-video-section {
            display: flex;
            margin-right: auto;
            margin-left: auto;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            }

            .frame-7481 {
            display: flex;
            margin-right: auto;
            margin-left: auto;
            justify-content: flex-start;
            align-items: center;
            flex: 0 auto;
            }

            .frame-7471-1 {
            -o-object-fit: fill;
                object-fit: fill;
            }

            .frame-7471-1.img-live1 {
            max-width: 80%;
            }

            .frame-7471-1.img-live-2 {
            max-width: 80%;
            }

            .text-8 {
            width: 100%;
            padding-right: 75px;
            padding-left: 75px;
            line-height: 100%;
            text-align: center;
            }

            .live-cta-bottom {
            display: flex;
            padding: 15px 20px;
            justify-content: center;
            margin-bottom: 4.5rem;
            margin-top: -4rem;
            align-items: center;
            flex: 0 auto;
            grid-column-gap: 24px;
            grid-row-gap: 24px;
            border-style: none;
            border-width: 1px;
            border-color: rgba(0, 128, 128, 0.3);
            border-radius: 15px;
            background-image: linear-gradient(212deg, teal, #23253d);
            }

            .live-cta-bottom:hover {
            box-shadow: 0 0 50px 17px teal;
            }

            .commencer {
            color: #80bfbf;
            font-size: 22px;
            font-weight: 700;
            text-align: center;
            }

            .commencer:hover {
            color: #dfe4e4;
            }

            .pr-te-embarquer-dans-cette-nouvelle-et-passionnante-aventure-qu-est-le-caf-crypto-0 {
            color: #cbebdc;
            font-size: 32px;
            line-height: 100%;
            font-weight: 500;
            text-align: center;
            letter-spacing: -0.05em;
            }

            .pr-te-embarquer-dans-cette-nouvelle-et-passionnante-aventure-qu-est-le-caf-crypto-1 {
            color: #fff;
            font-size: 32px;
            line-height: 100%;
            font-weight: 500;
            text-align: center;
            letter-spacing: -0.05em;
            }

            .client-section {
            display: flex;
            width: 100%;
            max-width: 1490px;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            grid-column-gap: 100px;
            grid-row-gap: 100px;
            }

            .container-4 {
            display: flex;
            width: 100%;
            height: 100%;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            grid-column-gap: 100px;
            grid-row-gap: 100px;
            }

            .client-cta {
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: flex-start;
            grid-column-gap: 148px;
            grid-row-gap: 6px;
            }

            .client-cta-1 {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex: 0 auto;
            grid-column-gap: 20px;
            grid-row-gap: 10px;
            }

            .vous-tes-d-butant-dans-l-cosyst-me-des-cryptomonnaies {
            color: #23253d;
            font-size: 40px;
            line-height: 100%;
            font-weight: 500;
            letter-spacing: -0.05em;
            margin-top: -5rem;
            }

            .client-cta-2 {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            grid-column-gap: 30px;
            grid-row-gap: 30px;
            }

            .recevez-les-conseils-des-professionnels-et-expert-du-domaine {
            color: #23253d;
            font-size: 26px;
            line-height: 100%;
            font-weight: 400;
            letter-spacing: -0.05em;
            margin-top: -3rem;
            }

            .client-bottom {
            display: flex;
            margin-top: 95px;
            padding: 15px 20px;
            justify-content: center;
            align-items: center;
            flex: 0 auto;
            grid-column-gap: 24px;
            grid-row-gap: 24px;
            border-style: solid;
            border-width: 1px;
            border-color: teal;
            border-radius: 15px;
            }

            .commencer-2 {
            color: teal;
            font-size: 25px;
            font-weight: 700;
            text-align: center;
            }

            .vectors-wrapper {
            display: flex;
            width: 18px;
            height: 6px;
            justify-content: center;
            align-items: center;
            grid-column-gap: 0px;
            grid-row-gap: 0px;
            -o-object-fit: cover;
                object-fit: cover;
            }

            .client-advantage {
            display: flex;
            width: 100%;
            margin-bottom:-6rem;
            /* height: 372px; */
            justify-content: flex-start;
            align-items: flex-start;
            grid-column-gap: 100px;
            grid-row-gap: 100px;
            }

            .enc-1-1 {
            -o-object-fit: contain;
                object-fit: contain;
            }

            .grid {
            margin-right: auto;
            margin-left: auto;
            align-items: center;
            -ms-grid-columns: 1fr 1fr 1fr;
            grid-template-columns: 1fr 1fr 1fr;
            -ms-grid-rows: auto;
            grid-template-rows: auto;
            -o-object-fit: fill;
                object-fit: fill;
            }

            .grid.live {
            grid-column-gap: 30px;
            }

            .grid-2 {
            -ms-grid-columns: 1fr;
            grid-template-columns: 1fr;
            }

            .grid-2.advg-gird {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            justify-items: stretch;
            align-items: stretch;
            align-content: stretch;
            grid-column-gap: 0px;
            grid-row-gap: 0px;
            }

            .image-2 {
            -o-object-fit: cover;
                object-fit: cover;
            }

            .grid-3 {
            -ms-grid-rows: auto;
            grid-template-rows: auto;
            }

            .grid-3.adv-section-grid {
            display: flex;
            margin-top: 80px;
            margin-right: auto;
            margin-left: auto;
            justify-content: space-between;
            align-items: stretch;
            align-content: stretch;
            }

            .grid-4 {
            -ms-grid-columns: 1fr 1fr 1fr;
            grid-template-columns: 1fr 1fr 1fr;
            -ms-grid-rows: auto;
            grid-template-rows: auto;
            }

            .grid-5 {
            grid-column-gap: 100px;
            -ms-grid-columns: 1fr 1fr 1fr;
            grid-template-columns: 1fr 1fr 1fr;
            -ms-grid-rows: auto;
            grid-template-rows: auto;
            }

            .image-3 {
            max-width: 100%;
            }

            .button-2 {
            margin-top: 95px;
            margin-right: auto;
            margin-left: auto;
            padding: 15px 20px;
            border-style: solid;
            border-width: 1px;
            border-color: teal;
            border-radius: 15px;
            background-color: rgba(56, 152, 236, 0);
            color: teal;
            font-size: 25px;
            font-weight: 600;
            }

            .button-2.client-adanv-butom {
            font-weight: 500;
            margin-bottom:4rem;
            }

            .button-2.client-adanv-butom:hover {
            background-image: linear-gradient(235deg, teal, #000);
            color: #f3f3f3;
            }

            .section-avantage-grid {
            grid-column-gap: 70px;
            grid-row-gap: 70px;
            -ms-grid-columns: 1fr;
            grid-template-columns: 1fr;
            -ms-grid-rows: auto auto auto;
            grid-template-rows: auto auto auto;
            }

            .grid-6 {
            -ms-grid-columns: 1fr;
            grid-template-columns: 1fr;
            }

            .grid-6.section-adventage-img-2 {
            grid-column-gap: 70px;
            grid-row-gap: 70px;
            }

            .section_adv.image_block_02 {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            }

            .grid-7 {
            align-content: stretch;
            -ms-grid-columns: 1fr;
            grid-template-columns: 1fr;
            -ms-grid-rows: auto auto;
            grid-template-rows: auto auto;
            }

            .div-block-4 {
            margin-top: 80px;
            }

            .who_crypto_section {
            display: flex;
            margin-top: 80px;
            flex-direction: row;
            justify-content: space-between;
            align-items: stretch;
            grid-auto-columns: 1fr;
            grid-column-gap: 16px;
            -ms-grid-columns: 1fr 1fr;
            grid-template-columns: 1fr 1fr;
            -ms-grid-rows: auto;
            grid-template-rows: auto;
            }

            .who_crypto_section_img01 {
            max-width: 680px;
            }

            .who_crypto_section_img02 {
            display: flex;
            max-width: 680px;
            flex-direction: column;
            justify-content: space-between;
            grid-row-gap: 10px;
            }

            .image-6 {
            max-width: 680px;
            -o-object-fit: contain;
                object-fit: contain;
            }

            .image-7 {
            display: block;
            }

            /* media */

            @media screen and (max-width: 991px) {
            .container.header {
                max-width: 705px;
            }

            .client-cta-2 {
                margin-top: -3rem;
            }

            .circle {
                width: 19px; /* Taille du cercle */
                height: 19px;
                background-color: #DC3F4D; /* Couleur du cercle */
                border-radius: 50%; /* Rend le div circulaire */
                margin-right: 0px; /* Espacement entre le cercle et le texte */
                margin-top:1.5rem;
            }
            

            .container.client-section {
                grid-row-gap: 0px;
            }

            .section.who {
                margin-top: 100px;
                margin-bottom: 100px;
            }

            .section.client {
                margin-top: 100px;
            }

            .titre-1.header {
                width: 164px;
                height: 45px;
            }

            .text-block {
                font-size: 20px;
            }

            .header_heading {
                font-size: 60px;
                line-height: 120%;
            }

            .header_heading.t2 {
                font-size: 60px;
                line-height: 130%;
            }

            .header_textblock {
                font-size: 20px;
                line-height: 110%;
            }


            .heder_title_01 {
                font-size: 40px;
                line-height: 130%;
            }

            .header_title_02 {
                width: 882px;
                font-size: 20px;
                line-height: 120%;
            }

            .who_title_01 {
                max-width: 400px;
            }

            .who_title_02 {
                width: auto;
                /* max-width: 250px; */
                font-size: 20px;
                line-height: 120%;
            }

            .who_title_text_01 {
                width: auto;
                font-size: 30px;
                line-height: 100%;
            }

            .who_title_text_02 {
                width: auto;
                font-size: 30px;
            }

            .who-condition {
                height: 100%;
                margin-top: 70px;
                padding-top: 0px;
                padding-bottom: 0px;
                justify-content: space-between;
                grid-column-gap: 0px;
                grid-row-gap: 30px;
            }

            .who-condition-01 {
                display: block;
                height: 100%;
            }

            .text {
                font-size: 30px;
                line-height: 100%;
            }

            .who-condition-02 {
                display: block;
                height: 100%;
            }

            .text-2 {
                font-size: 25px;
                line-height: 100%;
            }

            .who-condition-03 {
                display: block;
                height: 100%;
                font-size: 10px;
            }

            .text-3 {
                font-size: 20px;
                line-height: 100%;
            }

            .advantage-section {
                grid-column-gap: 50px;
                grid-row-gap: 98px;
            }

            .title-advantage-section {
                display: block;
                width: 100%;
            }

            .advantage-title {
                max-width: 732px;
            }

            .text-4 {
                font-size: 30px;
            }

            .vous-tes-un-professionnel-ou-un-expert-du-domaine-des-cryptomonnaies-partagez-vos-connaissances-en-tant-que-speaker-sur-les-lives-de-caf-crypto {
                font-size: 20px;
            }

            .container-3 {
                grid-row-gap: 76px;
            }

            .section-live-title {
                padding-right: 45px;
                padding-left: 45px;
            }

            .text-5 {
                font-size: 50px;
            }

            .text-6 {
                font-size: 50px;
            }

            .text-7 {
                font-size: 15px;
            }

            .text-8 {
                padding-right: 20px;
                padding-left: 20px;
            }

            .commencer {
                font-size: 20px;
            }

            .pr-te-embarquer-dans-cette-nouvelle-et-passionnante-aventure-qu-est-le-caf-crypto-0 {
                font-size: 30px;
            }

            .pr-te-embarquer-dans-cette-nouvelle-et-passionnante-aventure-qu-est-le-caf-crypto-1 {
                font-size: 30px;
                line-height: 150%;
            }

            .client-cta {
                align-items: center;
            }

            .vous-tes-d-butant-dans-l-cosyst-me-des-cryptomonnaies {
                font-size: 30px;
            }

            .recevez-les-conseils-des-professionnels-et-expert-du-domaine {
                font-size: 20px;
            }

            .client-advantage {
                height: 100%;
                grid-column-gap: 0px;
            }

            .grid.live {
                grid-column-gap: 0px;
            }

            .grid-2.advg-gird {
                justify-items: stretch;
                align-items: stretch;
                align-content: stretch;
            }

            .grid-3.adv-section-grid {
                flex-direction: column;
                align-items: center;
                -ms-grid-columns: 1.25fr 1fr;
                grid-template-columns: 1.25fr 1fr;
            }

            .grid-5.section-client-adventage {
                grid-column-gap: 50px;
                grid-row-gap: 0px;
            }

            .button-2.client-adanv-butom {
                margin-top: 2rem;
                font-size: 15px;
            }

            .button{
                margin-top: 2rem;
                font-size: 16px;
            
            }

            .grid-6.section-adventage-img-2 {
                justify-content: stretch;
                align-content: stretch;
            }

            .image-4 {
                -o-object-fit: fill;
                object-fit: fill;
            }

            .section_adv.image_block_02 {
                grid-row-gap: 16px;
            }

            .who_crypto_section {
                margin-right: auto;
                margin-left: auto;
                flex-direction: column;
                grid-row-gap: 10px;
            }

            .who_crypto_section_img01 {
                max-width: 85%;
                margin-right: auto;
                margin-left: auto;
            }

            .who_crypto_section_img02 {
                align-items: center;
            }

            .body-2 {
                border: 1px none #000;
            }
            }

            @media screen and (max-width: 767px) {
            .container.client-section {
                grid-column-gap: 0px;
                grid-row-gap: 0px;
            }

            .circle {
                width: 19px; /* Taille du cercle */
                height: 19px;
                background-color: #DC3F4D; /* Couleur du cercle */
                border-radius: 50%; /* Rend le div circulaire */
                margin-right: 0px; /* Espacement entre le cercle et le texte */
                margin-top:1.5rem;
            }
            

            .section.client {
                margin-top: 115px;
            }

            .titre-1.header {
                width: 135px;
            }

            .text-block {
            font-size: 15px;
            }

            .header_heading {
                font-size: 50px;
            }

            .header_heading.t2 {
                font-size: 50px;
            }

            .header_textblock {
                font-size: 15px;
            }

            .heder_title_01 {
                font-size: 30px;
            }

            .header_title_02 {
                width: 100%;
                font-size: 15px;
                margin-left: 2rem;
            }

            .who_title_02 {
                font-size: 18px;
            }

            .who_title_text_01 {
                font-size: 25px;
            }

            .who_title_text_02 {
                font-size: 25px;
            }

            .text {
                font-size: 20px;
            }

            .text-2 {
                font-size: 18px;
            }

            .text-3 {
                font-size: 18px;
            }

            .title-advantage-section {
                display: block;
            }

            .text-4 {
                font-size: 25px;
            }

            .vous-tes-un-professionnel-ou-un-expert-du-domaine-des-cryptomonnaies-partagez-vos-connaissances-en-tant-que-speaker-sur-les-lives-de-caf-crypto {
                font-size: 18px;
            }

            .container-3 {
                grid-row-gap: 63px;
            }

            .text-5 {
                font-size: 30px;
            }

            .text-6 {
                font-size: 30px;
            }

            .text-7 {
                font-size: 14px;
            }

            .text-8 {
                line-height: 200%;
            }

            .commencer {
                font-size: 15px;
            }

            .pr-te-embarquer-dans-cette-nouvelle-et-passionnante-aventure-qu-est-le-caf-crypto-0 {
                font-size: 20px;
            }

            .pr-te-embarquer-dans-cette-nouvelle-et-passionnante-aventure-qu-est-le-caf-crypto-1 {
                font-size: 20px;
            }

            .client-section {
                grid-row-gap: 80px;
            }

            .client-cta {
                grid-column-gap: 112px;
            }

            .vous-tes-d-butant-dans-l-cosyst-me-des-cryptomonnaies {
                font-size: 20px;
            }

            .recevez-les-conseils-des-professionnels-et-expert-du-domaine {
                font-size: 18px;
            }

            .client-advantage {
                grid-row-gap: 100px;
            }

            .grid.live {
                grid-auto-flow: row;
                grid-column-gap: 0px;
            }

            .grid-5.section-client-adventage {
                grid-column-gap: 12px;
                grid-row-gap: 0px;
            }

            .button-2.client-adanv-butom {
                font-size: 12px;
                margin-top: 5rem;
            }

            .button{
                font-size: 12px;
                margin-top: 5rem;
            }

            .section-avantage-grid {
                grid-row-gap: 20px;
            }

            .grid-6.section-adventage-img-2 {
                grid-row-gap: 20px;
            }

            .who_crypto_section {
                max-width: 90%;
                margin-right: auto;
                margin-left: auto;
            }

            .live-cta-bottom{
                margin-top: 1rem;
            }

            .who_crypto_section_img01 {
                max-width: 100%;
            }
            }

            @media screen and (max-width: 479px) {
            .container.header {
                padding-top: 42px;
                padding-bottom: 42px;
            }

            .client-cta-2 {
                margin-top: 0.2rem;
            }


            .text-7 {
                margin-left: 0.2rem;
                font-size: 16px;
                margin-right: 0rem;
            }


            .circle {
                width: 19px; /* Taille du cercle */
                height: 19px;
                background-color: #DC3F4D; /* Couleur du cercle */
                border-radius: 50%; /* Rend le div circulaire */
                margin-right: 0px; /* Espacement entre le cercle et le texte */
                margin-top:1.5rem;
            }
            

            .section.who {
                margin-top: 50px;
                margin-bottom: 50px;
            }

            .section.advantage {
                margin-top: 65px;
            }

            .section .avantageStyle{
                margin-top: 4rem;
            }

            .section.client {
                margin-top: 60px;
            }

            .titre-1.header {
                width: 110px;
                height: 30px;
            }

            .text-block {
                font-size: 12px;
            }

            .header_heading {
                font-size: 30px;
                letter-spacing: 0px;
            }

            .header_heading.t2 {
                font-size: 30px;
            }

            .header_textblock {
                font-size: 12px;
                letter-spacing: 0px;
            }

            .button.header_buton {
                width: 128px;
                height: 20px;
                font-size: 11px;
                margin-top: 5rem;
                margin-bottom: 5rem;
            
            }

            /* correction */
            .button-2.client-adanv-butom {
                font-size: 12px;
                margin-top: 5rem;
            }

            /* .button {
                font-size: 10px;
                margin-top: 5rem;
                width:200px;
                
            }
            */
            
            .heder_video {
                margin-top: 40px;
                margin-bottom: 40px;
            }

            .header_title_cta {
                padding-top: 0px;
                padding-bottom: 0px;
                flex-direction: column;
            }

            .heder_title_01 {
                margin-bottom: 16px;
                font-size: 20px;
                text-align: left;
            }

            .header_title_02 {
                width: 100%;
                font-size: 12px;
                margin-left: 5.5rem;
            }

            .who_title {
                flex-direction: column;
                grid-row-gap: 20px;
            }

            .who_title_01 {
                grid-row-gap: 8px;
            }

            .who_title_02 {
                letter-spacing: -1px;
            }

            .who_title_text_01 {
                letter-spacing: -1px;
            }

            .who_title_text_02 {
                letter-spacing: -1px;
            }

            .who-condition {
                margin-top: 40px;
                grid-row-gap: 17px;
            }

            .text-2 {
                font-size: 18px;
                letter-spacing: 0em;
                line-height: 1.5;
            }

            .text-3 {
                font-size: 16px;
                letter-spacing: 0em;
                line-height: 1.5;
            }

            .advantage-section {
                flex-direction: column;
                grid-row-gap: 20px;
            }

            .title-advantage-section {
                display: block;
            }

            .text-4 {
                font-size: 20px;
            }

            .vous-tes-un-professionnel-ou-un-expert-du-domaine-des-cryptomonnaies-partagez-vos-connaissances-en-tant-que-speaker-sur-les-lives-de-caf-crypto {
                font-size: 16px;
            }

            .container-3 {
                grid-row-gap: 43px;
            }

            .section-live-title {
                flex-direction: column;
                grid-column-gap: 86px;
                grid-row-gap: 20px;

            }

            .frame-7471-1 {
                display: none;
            }

            .frame-7471-1.img-live1 {
                display: block;
                max-width: 100%;
            }

            .frame-7471-1.img-live-2 {
                display: none;
            }

            .text-8 {
                padding-right: 0px;
                padding-left: 0px;
                line-height: 180%;
            }

            .commencer {
                font-size: 12px;
            }

            .pr-te-embarquer-dans-cette-nouvelle-et-passionnante-aventure-qu-est-le-caf-crypto-0 {
                font-size: 18px;
            }

            .pr-te-embarquer-dans-cette-nouvelle-et-passionnante-aventure-qu-est-le-caf-crypto-1 {
                font-size: 18px;
            }

            .client-section {
                grid-row-gap: 49px;
                margin-top: 10rem;
            }

            .client-cta {
                flex-direction: column;
                grid-row-gap: 20px;
            }

            .recevez-les-conseils-des-professionnels-et-expert-du-domaine {
                font-size: 15px;
                margin-top:-1.2rem;
                
            }

            .grid.live {
                display: flex;
                padding-right: 35px;
                padding-left: 35px;
                grid-column-gap: 14px;
            }

            .grid-5.section-client-adventage {
                display: flex;
                flex-direction: column;
                grid-row-gap: 30px;
            }

            .who_crypto_section {
                max-width: 100%;
                margin-top: 40px;
            }

            .live-cta-bottom{
                margin-top: 1rem;
            }
            }


            /* Media query pour les écrans de largeur maximale de 767px (mobile) */
            @media (max-width: 487px) {
            /* Cible la grille contenant les premières images */
            .w-layout-grid.section-avantage-grid {
                grid-template-columns: 1fr; /* Une seule colonne */
                grid-template-rows: auto auto auto auto; /* Réorganise les images en lignes */
            }

            /* Réorganise chaque image */
            .img-adv-01 {
                grid-row: 3; /* Change la position de l'image */
            }

            .img-adv-02 {
                grid-row: 4;
            }

            /* Cible la grille contenant les deux autres images */
            .w-layout-grid.grid-6.section-adventage-img-2 {
                grid-template-columns: 1fr; /* Une seule colonne */
                grid-template-rows: auto auto;
            }

            /* Réorganise les images */
            .img-adv-03 {
                grid-row: 1;
            }

            .img-adv-04 {
                grid-row: 2;
            }
            }




            /* @media (min-width: 380px) and (max-width: 400px) {
            .who_title_02 {
                
                margin-right: -2rem;
                color:#DC3F4D;
            }

            } */


            #w-node-f6203e39-324d-6429-ce6e-65bfb3a436be-f9c28dc9 {
            -ms-grid-column: span 1;
                grid-column-start: span 1;
            -ms-grid-column-span: 1;
            grid-column-end: span 1;
            -ms-grid-row: span 1;
                grid-row-start: span 1;
            -ms-grid-row-span: 1;
            grid-row-end: span 1;
            }

            #w-node-f6203e39-324d-6429-ce6e-65bfb3a436c0-f9c28dc9 {
            -ms-grid-column: span 1;
                grid-column-start: span 1;
            -ms-grid-column-span: 1;
            grid-column-end: span 1;
            -ms-grid-row: span 1;
                grid-row-start: span 1;
            -ms-grid-row-span: 1;
            grid-row-end: span 1;
            }

            #w-node-_8cf73968-0ede-7c76-fddc-1800cdb8793d-f9c28dc9 {
            -ms-grid-column: span 1;
                grid-column-start: span 1;
            -ms-grid-column-span: 1;
            grid-column-end: span 1;
            -ms-grid-row: span 1;
                grid-row-start: span 1;
            -ms-grid-row-span: 1;
            grid-row-end: span 1;
            }

            #w-node-_38812f5a-e85c-8197-9f66-598ce3a1708a-f9c28dc9 {
            -ms-grid-column: span 1;
                grid-column-start: span 1;
            -ms-grid-column-span: 1;
            grid-column-end: span 1;
            -ms-grid-row: span 1;
                grid-row-start: span 1;
            -ms-grid-row-span: 1;
            grid-row-end: span 1;
            }

            #w-node-eae93669-eb5c-0dca-ff6a-9f42319a89ba-f9c28dc9 {
            -ms-grid-column-align: end;
                justify-self: end;
            }

            #w-node-_9e0a756c-5267-5d3b-7e26-3e13c2d84bfd-f9c28dc9 {
            -ms-grid-column: span 1;
                grid-column-start: span 1;
            -ms-grid-column-span: 1;
            grid-column-end: span 1;
            -ms-grid-row: span 1;
                grid-row-start: span 1;
            -ms-grid-row-span: 1;
            grid-row-end: span 1;
            }

            #w-node-_73a43c8f-70ee-f8b1-aad8-569f29a4e88d-f9c28dc9 {
            -ms-grid-column: span 1;
                grid-column-start: span 1;
            -ms-grid-column-span: 1;
            grid-column-end: span 1;
            -ms-grid-row: span 1;
                grid-row-start: span 1;
            -ms-grid-row-span: 1;
            grid-row-end: span 1;
            }

            #w-node-_2f7494fc-0bf0-2c10-698a-2b4469218c12-f9c28dc9 {
            -ms-grid-column: span 1;
                grid-column-start: span 1;
            -ms-grid-column-span: 1;
            grid-column-end: span 1;
            -ms-grid-row: span 1;
                grid-row-start: span 1;
            -ms-grid-row-span: 1;
            grid-row-end: span 1;
            }

            @media screen and (max-width: 991px) {
            #w-node-eae93669-eb5c-0dca-ff6a-9f42319a89b9-f9c28dc9 {
                -ms-grid-row: span 1;
                    grid-row-start: span 1;
                -ms-grid-row-span: 1;
                grid-row-end: span 1;
                -ms-grid-column: span 1;
                    grid-column-start: span 1;
                -ms-grid-column-span: 1;
                grid-column-end: span 1;
            }
            }

            @media screen and (max-width: 479px) {
            #w-node-f6203e39-324d-6429-ce6e-65bfb3a436b7-f9c28dc9 {
                -ms-grid-row-align: auto;
                    align-self: auto;
            }
            }

            @font-face {
            font-family: 'Geometria';
            src: url('/cafecrypto/fonts/Geometria.ttf') format('truetype');
            font-weight: 100;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'Geometria';
            src: url('/cafecrypto/fonts/Geometria-Bold.ttf') format('truetype'), url('/cafecrypto/fonts/Geometria-ExtraBold.ttf') format('truetype');
            font-weight: 700;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'Geometria';
            src: url('/cafecrypto/fonts/Geometria.ttf') format('truetype');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'Geometria';
            src: url('/cafecrypto/fonts/Geometria-Medium.ttf') format('truetype');
            font-weight: 500;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'Geometria';
            src: url('/cafecrypto/fonts/Geometria-Thin.ttf') format('truetype');
            font-weight: 300;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'Geometria';
            src: url('/cafecrypto/fonts/Geometria-Heavy.ttf') format('truetype');
            font-weight: 600;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'The northern block ltd typold';
            src: url('/cafecrypto/fonts/The-Northern-Block-Ltd---Typold-Regular.otf') format('opentype');
            font-weight: 400;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'The northern block ltd typold';
            src: url('/cafecrypto/fonts/The-Northern-Block-Ltd---Typold-Thin.otf') format('opentype');
            font-weight: 100;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'The northern block ltd typold';
            src: url('/cafecrypto/fonts/The-Northern-Block-Ltd---Typold-Medium.otf') format('opentype');
            font-weight: 500;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'The northern block ltd typold';
            src: url('/cafecrypto/fonts/The-Northern-Block-Ltd---Typold-Light.otf') format('opentype');
            font-weight: 300;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'The northern block ltd typold';
            src: url('/cafecrypto/fonts/The-Northern-Block-Ltd---Typold-ExtraBold.otf') format('opentype');
            font-weight: 700;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'The northern block ltd typold';
            src: url('/cafecrypto/fonts/The-Northern-Block-Ltd---Typold-Bold.otf') format('opentype');
            font-weight: 900;
            font-style: normal;
            font-display: swap;
            }
            @font-face {
            font-family: 'The northern block ltd typold';
            src: url('/cafecrypto/fonts/The-Northern-Block-Ltd---Typold-Black-Italic.otf') format('opentype');
            font-weight: 600;
            font-style: italic;
            font-display: swap;
            } 
    </style>
    </head>
    <body class="body-2">
   
    <div class="section header">
      <div class="container header">
        <div class="titre-1 header">
            <div class="text-block" style="font-weight:400px;">Café Crypto</div>
        </div>
        <div class="header_heading_title">
            <h1 class="header_heading" style="margin-bottom:-2rem;">Partagez vos connaissances sur la</h1>
            <h1 class="header_heading t2" style="background: linear-gradient(90deg, #5B8AF0 0%, #DC3F4D 100%);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">Blockchain, les Cryptos et le Web 3</h1>
        </div>
        <div class="" style="font-size:18px; color:white; text-align:center; font-weight:100;">Aidez notre/votre communauté à s’instruire et à être à jour <br>vis-à-vis de l&#x27;écosystème des cryptomonnaies</div>
        <a href="/new-speaker" class="button header_buton w-button" style="margin-top:2rem; margin-bottom:-2rem;">Devenez Speaker</a>
        
        <div class="header_video_section" style="width:100%;">
            <div style="padding-top:56.17021276595745%;" class="w-embed-youtubevideo heder_video"><iframe src="https://www.youtube.com/embed/F3ZHyCMweks?rel=0&amp;controls=1&amp;autoplay=1&amp;mute=1&amp;start=0" frameborder="0" style="position:absolute;left:0;top:0;width:100%;height:100%; border-radius:45px;" allow="autoplay; encrypted-media" allowfullscreen="" title="Sur IZICHANGE nos tarifs sont sans frais"></iframe></div>
        </div>   
          
        <div class="light-effect"></div>

        <div class="header_title_cta">
            <div class="heder_title_01">Éduquez et sensibilisez sur les divers risques et opportunités</div>
            <div class="header_title_02">liés à la technologie Blockchain <br>aux Cryptomonnaies <br>et  au Web 3</div>
        </div>
      </div>
    </div>

    <div class="section who wf-section">
        <div class="who container">
           <div class="who_title">
                <div class="who_title_01">
                    <div class="who_title_text_01">Vous êtes un professionnel ou un expert</div>
                    <div class="who_title_text_02">du domaine des cryptomonnaies ?</div>
                </div>
                <div class="who_title_02">Partagez vos connaissances en tant que <strong>Speaker</strong> sur les Lives de Café Crypto.</div>
            </div>
            <div class="who_crypto_section">
                <div class="who_crypto_section_img01">
                    <img src="/cafecrypto/images/crypto-img-adv-3.png" loading="lazy" width="663" sizes="(max-width: 479px) 83vw, (max-width: 767px) 81vw, (max-width: 991px) 590px, 49vw" srcset="/cafecrypto/images/crypto-img-adv-3-p-500.png"  alt="" class="image-7">
                </div>
                <div class="who_crypto_section_img02">
                    <div class="who_crypto_img_01"><img src="/cafecrypto/images/Who-1-1.png" loading="lazy" width="585" sizes="(max-width: 479px) 83vw, (max-width: 767px) 79vw, (max-width: 991px) 585px, 44vw" srcset="/cafecrypto/images/Who-1-1-p-500.png 500w, /cafecrypto/images/Who-1-1-p-800.png 800w, /cafecrypto/images/Who-1-1-p-1080.png 1080w, /cafecrypto/images/Who-1-1.png 1334w" alt=""></div>
                    <div class="who_crypto_img_02"><img src="/cafecrypto/images/Who-2-1.png" loading="lazy" width="590" sizes="(max-width: 479px) 83vw, (max-width: 767px) 79vw, (max-width: 991px) 590px, 44vw" srcset="/cafecrypto/images/Who-2-1-p-500.png 500w, /cafecrypto/images/Who-2-1-p-800.png 800w, /cafecrypto/images/Who-2-1-p-1080.png 1080w, /cafecrypto/images/Who-2-1.png 1334w" alt=""></div>
                </div>
            </div>
            <div class="who-condition">
                <div class="who-condition-01">
                  
                    <span class="text" style="">Condition à Remplir</span>
                </div>
                <div class="who-condition-02">
                <div class="text-2">Avoir une certaine base de connaissances et d&#x27;expérience dans le domaine de la blockchain, des cryptos et du web 3</div>
                </div>
                <div class="who-condition-03">
                <div class="text-3">L’univers de la blockchain, des cryptos et de la web 3 n’est plus un secret pour vous ?
                    Vous vous sentez à l’aise lors des débats ou discussions ayant trait à cet univers passionnant que constituent les cryptomonnaies ? Café Crypto est fait pour vous.</div>
                </div>
            </div>
        </div>
    </div>
    <div class="section advantage wf-section" style="margin-top:-5rem;">
        <div class="container advantage">
        <div class="advantage-section">
            <div class="w-layout-grid section-avantage-grid">
                <div id="w-node-f6203e39-324d-6429-ce6e-65bfb3a436b7-f9c28dc9" class="title-advantage-section">
                    <div class="advantage-title avantageStyle">
                    <div class="text-4">Quels sont les Avantages ?</div>
                    </div>
                    <div class="advantage-title">
                    <div class="vous-tes-un-professionnel-ou-un-expert-du-domaine-des-cryptomonnaies-partagez-vos-connaissances-en-tant-que-speaker-sur-les-lives-de-caf-crypto">Être speaker sur Café Crypto, c’est bénéficier d’une multitude d’avantages, exclusifs et adaptés <br>à chaque hôte.</div>
                    </div>
                </div>
                <div id="w-node-f6203e39-324d-6429-ce6e-65bfb3a436be-f9c28dc9" class="img-adv-01"><img src="/cafecrypto/images/Adv-01.png" loading="lazy" sizes="(max-width: 479px) 83vw, (max-width: 767px) 42vw, (max-width: 991px) 44vw, 41vw" srcset="/cafecrypto/images/Adv-01-p-500.png 500w, /cafecrypto/images/Adv-01.png 660w" alt=""></div>
                <div id="w-node-f6203e39-324d-6429-ce6e-65bfb3a436c0-f9c28dc9" class="img-adv-02"><img src="/cafecrypto/images/Adv-02.png" loading="lazy" sizes="(max-width: 479px) 83vw, (max-width: 767px) 42vw, (max-width: 991px) 44vw, 41vw" srcset="/cafecrypto/images/Adv-02-p-500.png 500w, /cafecrypto/images/Adv-02.png 660w" alt=""></div>
            </div>
            <div class="w-layout-grid grid-6 section-adventage-img-2">
                <div style="margin-top:2rem;" id="w-node-_8cf73968-0ede-7c76-fddc-1800cdb8793d-f9c28dc9" class="img-adv-03"><img src="/cafecrypto/images/Adv-03.png" loading="lazy" sizes="(max-width: 479px) 83vw, (max-width: 767px) 42vw, (max-width: 991px) 43vw, 41vw" srcset="/cafecrypto/images/Adv-03-p-500.png 500w, /cafecrypto/images/Adv-03.png 660w" alt=""></div>
                <div id="w-node-_38812f5a-e85c-8197-9f66-598ce3a1708a-f9c28dc9" class="img-adv-04"><img src="/cafecrypto/images/Adv-04.png" loading="lazy" sizes="(max-width: 479px) 83vw, (max-width: 767px) 42vw, (max-width: 991px) 43vw, 41vw" srcset="/cafecrypto/images/Adv-04-p-500.png 500w, /cafecrypto/images/Adv-04.png 660w" alt=""></div>
            </div>
        </div>
        </div>
    </div>
    <div class="section live-section wf-section">
        <div class="live-section container">
        <div class="container-3">
            <div class="section-live-title">
                <div class="live-title">
                    <div class="live-title-02">
                    <div class="text-5">Nos Lives</div>
                    </div>
                    <div class="live-title-02">
                    <div class="text-6">Café Crypto</div>
                    </div>
                </div>
                <div class="live-title-02">
                    <div class="text-7">Devenez un véritable acteur du changement intellectuel et financier de milliers d&#x27;amateurs et passionnées de cet écosystème. </div>
                </div>
            </div>
            <div class="w-layout-grid grid live"><img src="/cafecrypto/images/vid-2.png" loading="lazy" height="" sizes="(max-width: 479px) 85vw, (max-width: 760px) 80vw, 608px" srcset="/cafecrypto/images/vid-2-p-500.png 500w, /cafecrypto/images/vid-2.png 608w" alt="" class="frame-7471-1 img-live1"><img src="/cafecrypto/images/vid-1.png" loading="lazy" height="" id="w-node-eae93669-eb5c-0dca-ff6a-9f42319a89b9-f9c28dc9" srcset="/cafecrypto/images/vid-1-p-500.png 500w, /cafecrypto/images/vid-1-p-800.png 800w, /cafecrypto/images/vid-1.png 810w" sizes="(max-width: 810px) 100vw, 810px" alt="" class="frame-7471-1"><img src="/cafecrypto/images/vid-3.png" loading="lazy" height="" id="w-node-eae93669-eb5c-0dca-ff6a-9f42319a89ba-f9c28dc9" srcset="/cafecrypto/images/vid-3-p-500.png 500w, /cafecrypto/images/vid-3.png 608w" sizes="(max-width: 479px) 100vw, (max-width: 760px) 80vw, 608px" alt="" class="frame-7471-1 img-live-2"></div>
            <div class="live-title-02">
            <div class="text-8">
                <div class="text-8 text-8"><span class="pr-te-embarquer-dans-cette-nouvelle-et-passionnante-aventure-qu-est-le-caf-crypto-0">Prêt(e) à embarquer</span><span class="pr-te-embarquer-dans-cette-nouvelle-et-passionnante-aventure-qu-est-le-caf-crypto-1"> dans cette nouvelle et <br>passionnante aventure qu’est le </span><span class="pr-te-embarquer-dans-cette-nouvelle-et-passionnante-aventure-qu-est-le-caf-crypto-0">Café Crypto ?</span></div>
            </div>
            </div>
            <div class="live-cta-bottom">
            <a href="/new-speaker" class="commencer">Devenez Speaker sur Café Crypto</a>
            </div>
        </div>
        </div>
    </div>
    <div class="section client wf-section">
        <div class="container">
        <div class="client-section">
            <div class="client-cta">
            <div class="client-cta-1">
                <div class="vous-tes-d-butant-dans-l-cosyst-me-des-cryptomonnaies">Vous êtes débutant dans
                l’écosystème des
                cryptomonnaies ?</div>
            </div>
            <div class="client-cta-2">
                <div class="client-cta-1">
                <div class="recevez-les-conseils-des-professionnels-et-expert-du-domaine">Recevez les conseils des professionnels
                    et experts du domaine </div>
                </div>
            </div>
            </div>
            <div class="client-advantage">
                <div class="w-layout-grid grid-5 section-client-adventage">
                    <div id="w-node-_9e0a756c-5267-5d3b-7e26-3e13c2d84bfd-f9c28dc9" class="client-div-2 section_client"><img src="/cafecrypto/images/Enc-1-1.png" loading="lazy" width="417" sizes="(max-width: 767px) 83vw, 417px" srcset="/cafecrypto/images/Enc-1-1-p-500.png 500w, /cafecrypto/images/Enc-1-1-p-800.png 800w, /cafecrypto/images/Enc-1-1.png 860w" alt="" class="image-3 client"></div>
                    <div id="w-node-_73a43c8f-70ee-f8b1-aad8-569f29a4e88d-f9c28dc9" class="client-div-2"><img src="/cafecrypto/images/Enc-2-1.png" loading="lazy" sizes="(max-width: 479px) 83vw, (max-width: 767px) 90vw, (max-width: 945px) 91vw, 860px" srcset="/cafecrypto/images/Enc-2-1-p-500.png 500w, /cafecrypto/images/Enc-2-1-p-800.png 800w, /cafecrypto/images/Enc-2-1.png 860w" alt=""></div>
                    <div id="w-node-_2f7494fc-0bf0-2c10-698a-2b4469218c12-f9c28dc9"><img src="/cafecrypto/images/Enc-3-1.png" loading="lazy" sizes="(max-width: 479px) 83vw, (max-width: 767px) 90vw, (max-width: 945px) 91vw, 860px" srcset="/cafecrypto/images/Enc-3-1-p-500.png 500w, /cafecrypto/images/Enc-3-1-p-800.png 800w, /cafecrypto/images/Enc-3-1.png 860w" alt=""></div>
                </div>
            </div>
            <a href="/new-speaker" class="button-2 client-adanv-butom w-button"> Devenez Speaker sur Café Crypto </a>
        </div>
        </div>
    </div>
    
    <script src="https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=64119055c2ce06817ac28dc8" type="text/javascript" integrity="sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0=" crossorigin="anonymous"></script>
    <script src="js/webflow.js" type="text/javascript"></script>
    <!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->
    </body>
    </html>
`;

  const HtmlToReactParser = HtmlToReact.Parser;
  const htmlToReactParser = new HtmlToReactParser();
  const reactElement = htmlToReactParser.parse(htmlInput);
  React.useEffect(() => {    
    if (document.getElementById('footerCustom')) 
       document.getElementById('footerCustom').style.display = 'none';   
    }, [])
    
        return (
            <div>
                {reactElement}
            </div>
        );
    }

export default CafeCryptoContent;
